<template>
  <div class="ratings" resmed-component-name="ratings">
    <span class="rating-count" v-if="ratingsCount(id)"
      >&plus; {{ ratingsCount(id) }}</span
    >
    <button @click="toggleRating(id)" type="button" class="ctaButton">
      <img v-if="isRated(id)" src="@/assets/images/icon-thumbs-up.svg" />
      <img v-if="!isRated(id)" src="@/assets/images/icon-thumbs-up-grey.svg" />
    </button>
  </div>
</template>

<script>
export default {
  name: "ratings", // ratings
  props: ["type", "id"],
  data() {
    return {
      ratingsMap: {},
      userRatings: [],
    };
  },
  methods: {
    isRated(id) {
      return this.userRatings.includes(id);
    },
    toggleRating(id) {
      axios
        .post(`//${location.hostname}/wp-json/resmed/v1/ratings/rate`, {
          rateable_id: id,
          rateable_type: this.type,
        })
        .then((response) => {
          if (response.data) {
            if (!this.userRatings.includes(id)) {
              this.userRatings.push(id);
            }

            this.ratingsMap = {
              ...this.ratingsMap,
              [id]: Number(this.ratingsMap[id] || 0) + 1,
            };
          }
        });
    },
    refreshRatings() {
      axios
        .get(`https://support-dev.resmed.com/en-au/wp-json/resmed/v1/ratings`, {
          params: {
            rateable_ids: !this.$parent.ids ? [this.id] : this.$parent.ids,
            rateable_type: this.type,
          },
          headers: {
            "X-Bypass-Cache": true,
          },
        })
        .then((response) => {
          this.ratingsMap = response.data.ratings;
          this.userRatings = response.data.user_ratings;
        });
    },
    ratingsCount(id) {
      return this.ratingsMap[id];
    },
  },
  created() {
    this.refreshRatings();
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.ratings {
  display: flex;
  justify-content: flex-end;

  .rating-count {
    @extend %body-small-bold;

    font-size: 0.813em; // overwrite;
    color: $cc-resmed-pulse-blue;
    transform: translateY(3px);
  }

  button {
    background-color: rgba(255, 255, 255, 0);
    img {
      width: 19px;
      height: auto;
    }
  }
}
</style>